// CompanyRegistrationDubai.jsx
import React from "react";

export default function CompanyRegistrationDubai() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Company Registration Dubai
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Company Registration in Dubai - UAE Mainland & Free Zones
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses with Company Registration in
            Dubai, ensuring compliance with UAE corporate and regulatory
            frameworks across Mainland, Free Zones, and Offshore jurisdictions.
          </p>
          <p className="text-gray-700">
            From trade name reservation through DED license application, MOA
            notarization, Ejari tenancy registration, and establishment card
            issuance, the complete incorporation process enables rapid UAE market
            entry with 100% foreign ownership options.
          </p>
        </div>

        {/* Right: Image (Dubai Business Bay skyline) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1200&q=80"
              alt="Dubai Business Bay skyline for company registration UAE"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Dubai Company Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks coordinates complete documentation for DED,
              Free Zone, and DMCC approvals across UAE jurisdictions.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Passport copies of shareholders/directors (valid minimum 6 months).</li>
                <li>Proof of address (utility bills, bank statements for shareholders).</li>
                <li>
                  Business activity details including trade name, license
                  category, share capital, and legal structure (LLC, FZE, Branch).
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm provides comprehensive UAE incorporation services with
              local partnerships and regulatory expertise across jurisdictions.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Expertise in UAE Corporate Laws
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete knowledge of Mainland DED licensing, Free Zone rules,
                  DMCC/DFC regulations, 100% foreign ownership laws, and UAE
                  Companies Law compliance requirements.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Structured Incorporation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Systematic process from trade name approval through MOA
                  attestation, Ejari registration, immigration quota setup, and
                  establishment card issuance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Assistance
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end UAE market entry including PRO services, visa
                  processing, VAT registration, corporate bank account setup, and
                  ongoing compliance advisory across Dubai, Abu Dhabi, Sharjah.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
